var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78019 3.6001H5.07431C4.51268 3.6001 3.97405 3.82135 3.57691 4.21517C3.17977 4.609 2.95667 5.14314 2.95667 5.7001V18.3001C2.95667 18.8571 3.17977 19.3912 3.57691 19.785C3.97405 20.1788 4.51268 20.4001 5.07431 20.4001H8.78019M9.04338 12.0001H21.0434M21.0434 12.0001L16.4582 7.2001M21.0434 12.0001L16.4582 16.8001",
    stroke: "#6882B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ebc5ebd7f8d32c8a957ef081c79b5ade.svg";
export { ForwardRef as ReactComponent };